import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { PathwayTypeToLabel } from '@app/pathway-shared';
import { ICONS, Renderer_SearchResult } from '@app/styles';
import { ModuleFE_Pathway, ModuleFE_PathwayTransition } from '../../_entity.js';
import { Component_GenericRenderer, EditableDBItemV3, openContent } from '@nu-art/thunderstorm-frontend';
import { ModuleFE_Expression, ModuleFE_Tag } from '@app/hcs-frontend';
class Class_PathwaySearchItem {
    clearTimeout;
    pathwayErrorMap;
    transitionErrorMap;
    //######################### Internal Logic #########################
    calculateTransitionErrorMap = () => {
        this.transitionErrorMap = ModuleFE_PathwayTransition.cache.all().reduce((map, transition) => {
            const resolutionFunction = ModuleFE_Expression.cache.unique(transition.resolutionFunctionId);
            if (!resolutionFunction)
                return map;
            const editableItem = new EditableDBItemV3(resolutionFunction, ModuleFE_Expression);
            try {
                editableItem.validate();
                map[transition._id] = editableItem.hasErrors();
            }
            catch (err) {
                map[transition._id] = true;
            }
            return map;
        }, {});
    };
    calculatePathwayErrorMap = () => {
        this.pathwayErrorMap = ModuleFE_Pathway.cache.all().reduce((map, pathway) => {
            const editablePathway = new EditableDBItemV3(pathway, ModuleFE_Pathway);
            //Resolve if the pathway itself has any errors
            try {
                editablePathway.validate();
                map[pathway._id] = editablePathway.hasErrors();
            }
            catch (err) {
                map[pathway._id] = true;
            }
            //Resolve if any of the pathway transitions have errors
            if (!map[pathway._id]) {
                const pathwayTransitions = ModuleFE_PathwayTransition.cache.filter(transition => transition.pathwayIds.includes(pathway._id));
                map[pathway._id] = pathwayTransitions.some(transition => this.transitionErrorMap[transition._id]);
            }
            return map;
        }, {});
    };
    load = () => {
        if (!this.transitionErrorMap)
            this.calculateTransitionErrorMap();
        if (!this.pathwayErrorMap)
            this.calculatePathwayErrorMap();
    };
    clear = () => {
        clearTimeout(this.clearTimeout);
        this.clearTimeout = setTimeout(() => {
            delete this.pathwayErrorMap;
            delete this.transitionErrorMap;
        }, 1000);
    };
    //######################### Public Logic #########################
    render = (props) => {
        this.load();
        const type = PathwayTypeToLabel[props.item.type];
        const tags = ModuleFE_Tag.getTagsLabelByTagGroups(props.item.tagGroups);
        this.clear();
        return _jsx(Renderer_SearchResult, { itemId: props.item._id, itemKey: ModuleFE_Pathway.dbDef.dbKey, itemLabel: props.item.label, labelIcon: props.item.underConstruction ?
                _jsx(ICONS.under_construction.component, { ...openContent.tooltip.top('under-construction', _jsx(_Fragment, { children: "Protocol under construction" }), { offset: 5 }) })
                : null, hierarchy: type, selected: props.selected, onClickCallback: props.onClickCallback, tags: tags, error: this.pathwayErrorMap[props.item._id], orgRenderer: _jsx(Component_GenericRenderer, { rendererKey: 'organization-permission-editor', props: {
                    item: props.item,
                    indicatorMode: true,
                    orgNameClassName: 'search-result__hierarchy'
                } }) });
    };
}
const PathwaySearchItem = new Class_PathwaySearchItem();
export const Renderer_PathwaySearchItem = PathwaySearchItem.render;
//# sourceMappingURL=Renderer_PathwaySearchItem.js.map